import { APP_MODULES } from './appModules';
import { DDX_MODULES } from './ddxModule';
import { EDDR_MODULES } from './eddrModules';
import { GLOBAL_BENCHMARK_MODULES } from './globalBenchmarkModules';
import { LESSONS_LEARNT_MODULES } from './lessonsLearntModule';
import { PLANNING_MODULES } from './planningPanelModules';
import { USER_ADMIN_MODULES } from './userAdminModules';
import { WELL_GUARDIAN_MODULES } from './wellGuardianModules';

export const MODULE_ROOT_PATHS = {
  // DRILLX SMART OPERATIONS
  [APP_MODULES.HOME]: '/',
  [APP_MODULES.WELL_HOME]: '/well-home',
  [APP_MODULES.KICK_PREDICTION]: '/kick-risk',
  [APP_MODULES.STUCK_PIPE_PREDICTION]: '/stuck-prediction',
  [APP_MODULES.KICK_DETECTION]: '/kick-detection',
  [APP_MODULES.PLANNING_CATALOGUE]: '/planning/catalogue',
  [APP_MODULES.PLANNING_PANEL]: '/planning/panel',
  [APP_MODULES.PROGRESS_FOLLOW_UP]: '/progress-follow-up',
  [APP_MODULES.LIVE_PERFORMANCE]: '/live-performance',
  [APP_MODULES.GLOBAL_BENCHMARK]: '/global-benchmark',
  [APP_MODULES.DRILLX_COCKPIT]: '/drillx-map',
  [APP_MODULES.EDDR]: '/eDDR',
  [APP_MODULES.ENERGY_EFFICIENCY]: '/energy-efficiency',
  [APP_MODULES.LESSONS_LEARNT]: '/lessons-learnt',
  [APP_MODULES.WELL_SETTINGS]: '/well-settings',
  [APP_MODULES.USER_ADMIN]: '/user-admin',
  [APP_MODULES.WELL_GROUPS]: '/user-admin',
  [APP_MODULES.WELLBORE_ADMIN]: '/wellbore-admin',
  [APP_MODULES.DATA_MANAGEMENT]: '/real-time-data-quality',
  [APP_MODULES.DDX_PO]: '/ddx',
  [APP_MODULES.ANTICOLLISION]: '/anti-collision',
  [APP_MODULES.LIVE_WELL_VISUALISATION]: '/well-view',
  [APP_MODULES.ROP_OPTIMIZATION]: '/rop-optimization',
  [APP_MODULES.GHOST_MODE]: '/ghost-mode',
  [APP_MODULES.ADMIN_PO]: '/admin-po',
  [APP_MODULES.GLOBAL_FEEDBACK]: `/global-feedback`,
  // WELL GUARDIAN
  [APP_MODULES.WELL_GUARDIAN]: '/well-guardian',
} as const;

export const EDDR_MODULE_ROOT_PATHS = {
  [EDDR_MODULES.EDDR_OVERVIEW]: '/overview',
  [EDDR_MODULES.EDDR_OPERATIONS_LOG]: '/operations-log',
  [EDDR_MODULES.EDDR_OPERATIONS_CURVES]: '/operations-curves',
  [EDDR_MODULES.EDDR_FLUIDS]: '/fluids',
  [EDDR_MODULES.EDDR_SAFETY]: '/safety',
  [EDDR_MODULES.EDDR_TRAJECTORY]: '/trajectory',
  [EDDR_MODULES.EDDR_BHA]: '/bha',
  [EDDR_MODULES.EDDR_WELL_ACTIVITY_HISTORY]: '/wellActivityHistory',
  [EDDR_MODULES.EDDR_PROGRESS_CURVE]: '/progressCurve',
} as const;

export const DDX_MODULE_ROOT_PATHS = {
  [DDX_MODULES.DDX_TAGGING_TOOL]: '/tagging-tool',
  [DDX_MODULES.DDX_NEW_DATASET]: '/new-dataset',
  [DDX_MODULES.DDX_TRAINING_DATASETS]: '/training-datasets',
} as const;

export const LESSONS_LEARNT_MODULE_ROOT_PATHS = {
  [LESSONS_LEARNT_MODULES.LESSONS_LEARNT_REGISTER]: '/register',
  [LESSONS_LEARNT_MODULES.LESSONS_LEARNT_WELL]: '/well',
  [LESSONS_LEARNT_MODULES.LESSONS_LEARNT_VIEW]: '/view',
} as const;

export const USER_ADMIN_MODULE_ROOT_PATHS = {
  [USER_ADMIN_MODULES.USER_ADMIN]: '/',
  [USER_ADMIN_MODULES.WELL_GROUPS]: '/well-groups',
} as const;

export const GLOBAL_BENCHMARK_ROOT_PATHS = {
  [GLOBAL_BENCHMARK_MODULES.GLOBAL_BENCHMARK_WELLS_SELECTION]: '/wells-selection',
  [GLOBAL_BENCHMARK_MODULES.GLOBAL_BENCHMARK_TIME_BREAKDOWN]: '/time-breakdown',
  [GLOBAL_BENCHMARK_MODULES.GLOBAL_BENCHMARK_BOP_OPERATIONS]: '/bop-operations',
  [GLOBAL_BENCHMARK_MODULES.GLOBAL_BENCHMARK_DRILLING]: '/drilling',
  [GLOBAL_BENCHMARK_MODULES.GLOBAL_BENCHMARK_TRIPPING]: '/tripping',
  [GLOBAL_BENCHMARK_MODULES.GLOBAL_BENCHMARK_CASING_RUNNING]: '/casing-running',
} as const;

export const PLANNING_ROOT_PATHS = {
  [PLANNING_MODULES.PLANNING_PLAN]: '/plan',
  [PLANNING_MODULES.PLANNING_OFFSET_SEQUENCES]: '/offset-sequences',
  [PLANNING_MODULES.PLANNING_OFFSET_TIME_VS_DEPTH]: '/offset-time-vs-depth',
  [PLANNING_MODULES.PLANNING_OFFSET_TIME_BREAKDOWN]: '/offset-time-breakdown',
} as const;

const DRILLX_SMART_OPERATIONS_PATHS = {
  HOME: `/`,
  WELLS: `/wells`,
  WELL_HOME: `${MODULE_ROOT_PATHS.WELL_HOME}/:wellboreId`,
  KICK_PREDICTION: `${MODULE_ROOT_PATHS.KICK_PREDICTION}/:wellboreId`,
  STUCK_PIPE_PREDICTION: `${MODULE_ROOT_PATHS.STUCK_PIPE_PREDICTION}/:wellboreId`,
  KICK_DETECTION: `${MODULE_ROOT_PATHS.KICK_DETECTION}/:wellboreId`,
  PLANNING_CATALOGUE: `${MODULE_ROOT_PATHS.PLANNING_CATALOGUE}`,
  PLANNING_EDIT: `${MODULE_ROOT_PATHS.PLANNING_PANEL}/:wellPlanId`,
  PLANNING_NEW_PLAN: `${MODULE_ROOT_PATHS.PLANNING_PANEL}/new${PLANNING_ROOT_PATHS.PLANNING_PLAN}`,
  PLANNING_PLAN: `${MODULE_ROOT_PATHS.PLANNING_PANEL}/:wellPlanId${PLANNING_ROOT_PATHS.PLANNING_PLAN}`,
  PLANNING_OFFSET_SEQUENCES: `${MODULE_ROOT_PATHS.PLANNING_PANEL}/:wellPlanId${PLANNING_ROOT_PATHS.PLANNING_OFFSET_SEQUENCES}`,
  PLANNING_OFFSET_TIME_VS_DEPTH: `${MODULE_ROOT_PATHS.PLANNING_PANEL}/:wellPlanId${PLANNING_ROOT_PATHS.PLANNING_OFFSET_TIME_VS_DEPTH}`,
  PLANNING_OFFSET_TIME_BREAKDOWN: `${MODULE_ROOT_PATHS.PLANNING_PANEL}/:wellPlanId${PLANNING_ROOT_PATHS.PLANNING_OFFSET_TIME_BREAKDOWN}`,
  PROGRESS_FOLLOW_UP: `${MODULE_ROOT_PATHS.PROGRESS_FOLLOW_UP}`,
  LIVE_PERFORMANCE: `${MODULE_ROOT_PATHS.LIVE_PERFORMANCE}/:wellboreId`,
  GLOBAL_BENCHMARK: `${MODULE_ROOT_PATHS.GLOBAL_BENCHMARK}`,
  GLOBAL_BENCHMARK_WELLS_SELECTION: `${MODULE_ROOT_PATHS.GLOBAL_BENCHMARK}${GLOBAL_BENCHMARK_ROOT_PATHS.GLOBAL_BENCHMARK_WELLS_SELECTION}`,
  GLOBAL_BENCHMARK_TIME_BREAKDOWN: `${MODULE_ROOT_PATHS.GLOBAL_BENCHMARK}${GLOBAL_BENCHMARK_ROOT_PATHS.GLOBAL_BENCHMARK_TIME_BREAKDOWN}`,
  GLOBAL_BENCHMARK_BOP_OPERATIONS: `${MODULE_ROOT_PATHS.GLOBAL_BENCHMARK}${GLOBAL_BENCHMARK_ROOT_PATHS.GLOBAL_BENCHMARK_BOP_OPERATIONS}`,
  GLOBAL_BENCHMARK_DRILLING: `${MODULE_ROOT_PATHS.GLOBAL_BENCHMARK}${GLOBAL_BENCHMARK_ROOT_PATHS.GLOBAL_BENCHMARK_DRILLING}`,
  GLOBAL_BENCHMARK_TRIPPING: `${MODULE_ROOT_PATHS.GLOBAL_BENCHMARK}${GLOBAL_BENCHMARK_ROOT_PATHS.GLOBAL_BENCHMARK_TRIPPING}`,
  GLOBAL_BENCHMARK_CASING_RUNNING: `${MODULE_ROOT_PATHS.GLOBAL_BENCHMARK}${GLOBAL_BENCHMARK_ROOT_PATHS.GLOBAL_BENCHMARK_CASING_RUNNING}`,
  DRILLX_COCKPIT: `${MODULE_ROOT_PATHS.DRILLX_COCKPIT}`,
  EDDR_OVERVIEW: `${MODULE_ROOT_PATHS.EDDR}${EDDR_MODULE_ROOT_PATHS.EDDR_OVERVIEW}/:tuwi`,
  EDDR_OPERATIONS_LOG: `${MODULE_ROOT_PATHS.EDDR}${EDDR_MODULE_ROOT_PATHS.EDDR_OPERATIONS_LOG}/:tuwi`,
  EDDR_OPERATIONS_CURVES: `${MODULE_ROOT_PATHS.EDDR}${EDDR_MODULE_ROOT_PATHS.EDDR_OPERATIONS_CURVES}/:wellboreId`,
  EDDR_PROGRESS_CURVE: `${MODULE_ROOT_PATHS.EDDR}${EDDR_MODULE_ROOT_PATHS.EDDR_PROGRESS_CURVE}/:tuwi`,
  EDDR_FLUIDS: `${MODULE_ROOT_PATHS.EDDR}${EDDR_MODULE_ROOT_PATHS.EDDR_FLUIDS}/:tuwi`,
  EDDR_SAFETY: `${MODULE_ROOT_PATHS.EDDR}${EDDR_MODULE_ROOT_PATHS.EDDR_SAFETY}/:tuwi`,
  EDDR_TRAJECTORY: `${MODULE_ROOT_PATHS.EDDR}${EDDR_MODULE_ROOT_PATHS.EDDR_TRAJECTORY}/:tuwi`,
  EDDR_BHA: `${MODULE_ROOT_PATHS.EDDR}${EDDR_MODULE_ROOT_PATHS.EDDR_BHA}/:tuwi`,
  EDDR_WELL_ACTIVITY_HISTORY: `${MODULE_ROOT_PATHS.EDDR}${EDDR_MODULE_ROOT_PATHS.EDDR_WELL_ACTIVITY_HISTORY}/:tuwi`,

  LESSONS_LEARNT_REGISTER: `${MODULE_ROOT_PATHS.LESSONS_LEARNT}${LESSONS_LEARNT_MODULE_ROOT_PATHS.LESSONS_LEARNT_REGISTER}`,
  LESSONS_LEARNT_WELL: `${MODULE_ROOT_PATHS.LESSONS_LEARNT}${LESSONS_LEARNT_MODULE_ROOT_PATHS.LESSONS_LEARNT_WELL}`,
  LESSONS_LEARNT_VIEW: `${MODULE_ROOT_PATHS.LESSONS_LEARNT}${LESSONS_LEARNT_MODULE_ROOT_PATHS.LESSONS_LEARNT_VIEW}/:lessonLearntId`,
  WELL_SETTINGS: `${MODULE_ROOT_PATHS.WELL_SETTINGS}/:wellboreId`,
  USER_ADMIN: `${MODULE_ROOT_PATHS.USER_ADMIN}${USER_ADMIN_MODULE_ROOT_PATHS.USER_ADMIN}`,
  WELL_GROUPS: `${MODULE_ROOT_PATHS.USER_ADMIN}${USER_ADMIN_MODULE_ROOT_PATHS.WELL_GROUPS}`,
  WELLBORE_ADMIN: `${MODULE_ROOT_PATHS.WELLBORE_ADMIN}`,
  GLOBAL_FEEDBACK: `/global-feedback`,
  DATA_MANAGEMENT: `${MODULE_ROOT_PATHS.DATA_MANAGEMENT}`,
  DDX_PO: MODULE_ROOT_PATHS.DDX_PO,
  DDX_TAGGING_TOOL: `${MODULE_ROOT_PATHS.DDX_PO}${DDX_MODULE_ROOT_PATHS.DDX_TAGGING_TOOL}`,
  DDX_NEW_DATASET: `${MODULE_ROOT_PATHS.DDX_PO}${DDX_MODULE_ROOT_PATHS.DDX_NEW_DATASET}`,
  DDX_TRAINING_DATASETS: `${MODULE_ROOT_PATHS.DDX_PO}${DDX_MODULE_ROOT_PATHS.DDX_TRAINING_DATASETS}`,
  ANTICOLLISION: `${MODULE_ROOT_PATHS.ANTICOLLISION}/:wellboreId`,
  ENERGY_EFFICIENCY_HOME: `${MODULE_ROOT_PATHS.ENERGY_EFFICIENCY}/home`,
  ENERGY_EFFICIENCY_RIG: `${MODULE_ROOT_PATHS.ENERGY_EFFICIENCY}/:tuwi/rig`,
  ENERGY_EFFICIENCY_WELL: `${MODULE_ROOT_PATHS.ENERGY_EFFICIENCY}/:tuwi/well`,
  WELL_VISUALISATION_PLANNED_DATA_FORM: `${MODULE_ROOT_PATHS.LIVE_WELL_VISUALISATION}/:tuwbi/planned-data-form`,
  ROP_OPTIMIZATION: `${MODULE_ROOT_PATHS.ROP_OPTIMIZATION}/:wellboreId`,
  GHOST_MODE: `${MODULE_ROOT_PATHS.GHOST_MODE}/:tuwbi`,
  ADMIN_PO: `${MODULE_ROOT_PATHS.ADMIN_PO}`,
} as const;

export const WELL_GUARDIAN_ROOT_PATHS = {
  [WELL_GUARDIAN_MODULES.WELL_HEALTH]: '/well-health',
  [WELL_GUARDIAN_MODULES.INTERVENTIONS]: '/interventions',
  [WELL_GUARDIAN_MODULES.DEROGATIONS]: '/derogations',
  [WELL_GUARDIAN_MODULES.SYNERGI_CASES]: '/synergi-cases',
  [WELL_GUARDIAN_MODULES.KEY_LINKS]: '/key-links',
  [WELL_GUARDIAN_MODULES.ALERTS_SUBSCRIPTION]: '/alerts-subscription',
} as const;

export const WELL_GUARDIAN_WELL_HEALTH_MODULE_ROOT_PATHS = {
  [WELL_GUARDIAN_MODULES.WELL_SINGLE_OVERVIEW]: '/overview',
  [WELL_GUARDIAN_MODULES.WELL_SINGLE_SCHEMATIC]: '/schematic',
  [WELL_GUARDIAN_MODULES.WELL_REVIEWS]: '/wellReviews',
  [WELL_GUARDIAN_MODULES.WELL_SINGLE_CHARTS]: '/charts',
  [WELL_GUARDIAN_MODULES.WELL_BEHAVIOUR]: '/behaviour',
  [WELL_GUARDIAN_MODULES.WELL_DGS_HSE]: '/integrityDetails',
  [WELL_GUARDIAN_MODULES.WELL_RESOURCE]: '/resources',
  [WELL_GUARDIAN_MODULES.WELL_ALERTS]: '/alerts',
} as const;

export const WELL_GUARDIAN_INTERVENTIONS_MODULE_ROOT_PATHS = {
  [WELL_GUARDIAN_MODULES.WIR_LIST]: '/wir-list',
  [WELL_GUARDIAN_MODULES.WIR_CREATION]: '/wir',
} as const;

export const WELL_GUARDIAN_PATHS = {
  WELL_GUARDIAN: `${MODULE_ROOT_PATHS.WELL_GUARDIAN}`,
  WELL_GUARDIAN_WELL_HEALTH_HOME: `${MODULE_ROOT_PATHS.WELL_GUARDIAN}${WELL_GUARDIAN_ROOT_PATHS.WELL_HEALTH}`,
  WELL_GUARDIAN_WELL_SINGLE_OVERVIEW: `${MODULE_ROOT_PATHS.WELL_GUARDIAN}${WELL_GUARDIAN_ROOT_PATHS.WELL_HEALTH}/:tuwi${WELL_GUARDIAN_WELL_HEALTH_MODULE_ROOT_PATHS.WELL_SINGLE_OVERVIEW}`,
  WELL_GUARDIAN_WELL_SINGLE_SCHEMATIC: `${MODULE_ROOT_PATHS.WELL_GUARDIAN}${WELL_GUARDIAN_ROOT_PATHS.WELL_HEALTH}/:tuwi${WELL_GUARDIAN_WELL_HEALTH_MODULE_ROOT_PATHS.WELL_SINGLE_SCHEMATIC}`,
  WELL_GUARDIAN_WELL_WELL_REVIEWS: `${MODULE_ROOT_PATHS.WELL_GUARDIAN}${WELL_GUARDIAN_ROOT_PATHS.WELL_HEALTH}/:tuwi${WELL_GUARDIAN_WELL_HEALTH_MODULE_ROOT_PATHS.WELL_REVIEWS}`,
  WELL_GUARDIAN_WELL_SINGLE_CHARTS: `${MODULE_ROOT_PATHS.WELL_GUARDIAN}${WELL_GUARDIAN_ROOT_PATHS.WELL_HEALTH}/:tuwi${WELL_GUARDIAN_WELL_HEALTH_MODULE_ROOT_PATHS.WELL_SINGLE_CHARTS}`,
  WELL_GUARDIAN_WELL_BEHAVIOUR: `${MODULE_ROOT_PATHS.WELL_GUARDIAN}${WELL_GUARDIAN_ROOT_PATHS.WELL_HEALTH}/:tuwi${WELL_GUARDIAN_WELL_HEALTH_MODULE_ROOT_PATHS.WELL_BEHAVIOUR}`,
  WELL_GUARDIAN_INTEGRITY_DETAILS: `${MODULE_ROOT_PATHS.WELL_GUARDIAN}${WELL_GUARDIAN_ROOT_PATHS.WELL_HEALTH}/:tuwi${WELL_GUARDIAN_WELL_HEALTH_MODULE_ROOT_PATHS.WELL_DGS_HSE}`,
  WELL_GUARDIAN_WELL_RESOURCES: `${MODULE_ROOT_PATHS.WELL_GUARDIAN}${WELL_GUARDIAN_ROOT_PATHS.WELL_HEALTH}/:tuwi${WELL_GUARDIAN_WELL_HEALTH_MODULE_ROOT_PATHS.WELL_RESOURCE}`,
  WELL_GUARDIAN_SINGLE_WELL_ALERTS: `${MODULE_ROOT_PATHS.WELL_GUARDIAN}${WELL_GUARDIAN_ROOT_PATHS.WELL_HEALTH}/:tuwi${WELL_GUARDIAN_WELL_HEALTH_MODULE_ROOT_PATHS.WELL_ALERTS}`,
  WELL_GUARDIAN_ALERTS_SUBSCRIPTION: `${MODULE_ROOT_PATHS.WELL_GUARDIAN}${WELL_GUARDIAN_ROOT_PATHS.ALERTS_SUBSCRIPTION}`,
  WELL_GUARDIAN_MULTIPLE_WELLS_ALERTS: `${MODULE_ROOT_PATHS.WELL_GUARDIAN}${WELL_GUARDIAN_ROOT_PATHS.WELL_HEALTH}${WELL_GUARDIAN_WELL_HEALTH_MODULE_ROOT_PATHS.WELL_ALERTS}`,
  WELL_GUARDIAN_INTERVENTIONS: `${MODULE_ROOT_PATHS.WELL_GUARDIAN}${WELL_GUARDIAN_ROOT_PATHS.INTERVENTIONS}`,
  WELL_GUARDIAN_DEROGATIONS: `${MODULE_ROOT_PATHS.WELL_GUARDIAN}${WELL_GUARDIAN_ROOT_PATHS.DEROGATIONS}`,
  WELL_GUARDIAN_SYNERGI_CASES: `${MODULE_ROOT_PATHS.WELL_GUARDIAN}${WELL_GUARDIAN_ROOT_PATHS.SYNERGI_CASES}`,
  WELL_GUARDIAN_KEY_LINK: `${MODULE_ROOT_PATHS.WELL_GUARDIAN}${WELL_GUARDIAN_ROOT_PATHS.KEY_LINKS}`,
  WELL_GUARDIAN_WIR_CREATION: `${MODULE_ROOT_PATHS.WELL_GUARDIAN}${WELL_GUARDIAN_ROOT_PATHS.INTERVENTIONS}/:country${WELL_GUARDIAN_INTERVENTIONS_MODULE_ROOT_PATHS.WIR_CREATION}/:wirId`,
};

export const PATHS = {
  ...DRILLX_SMART_OPERATIONS_PATHS,
  ...WELL_GUARDIAN_PATHS,
};

export type PATH = (typeof PATHS)[keyof typeof PATHS];

export const NOT_WELL_RELATED_PATHS = [
  DRILLX_SMART_OPERATIONS_PATHS.HOME,
  DRILLX_SMART_OPERATIONS_PATHS.GLOBAL_FEEDBACK,
  DRILLX_SMART_OPERATIONS_PATHS.PLANNING_CATALOGUE,
  DRILLX_SMART_OPERATIONS_PATHS.PLANNING_EDIT,
  DRILLX_SMART_OPERATIONS_PATHS.DRILLX_COCKPIT,
  DRILLX_SMART_OPERATIONS_PATHS.DATA_MANAGEMENT,
  DRILLX_SMART_OPERATIONS_PATHS.DDX_PO,
  DRILLX_SMART_OPERATIONS_PATHS.DDX_TAGGING_TOOL,
  DRILLX_SMART_OPERATIONS_PATHS.DDX_NEW_DATASET,
  DRILLX_SMART_OPERATIONS_PATHS.DDX_TRAINING_DATASETS,
  DRILLX_SMART_OPERATIONS_PATHS.USER_ADMIN,
  DRILLX_SMART_OPERATIONS_PATHS.WELL_GROUPS,
  DRILLX_SMART_OPERATIONS_PATHS.WELLBORE_ADMIN,
  DRILLX_SMART_OPERATIONS_PATHS.GLOBAL_BENCHMARK,
  DRILLX_SMART_OPERATIONS_PATHS.LESSONS_LEARNT_REGISTER,
  DRILLX_SMART_OPERATIONS_PATHS.GHOST_MODE,
  DRILLX_SMART_OPERATIONS_PATHS.ADMIN_PO,
] as const;

export const WELL_PREDICTION_PATH = [
  DRILLX_SMART_OPERATIONS_PATHS.STUCK_PIPE_PREDICTION,
  DRILLX_SMART_OPERATIONS_PATHS.KICK_PREDICTION,
] as const;
